import { TableColumn } from "../../models/tables/TableColumn";
import { COLUMN_TYPES } from "../COLUMN_TYPES";

export const TripHistoryColumns: TableColumn[] = [
    {
        name: "clientName", 
        displayName: "Name", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "companyName", 
        displayName: "Nickname", 
        dataType: COLUMN_TYPES.string, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    },
    {
        name: "dateAccredited", 
        displayName: "Date", 
        dataType: COLUMN_TYPES.date, 
        isEditable: false, 
        isEditableOnNew: false, 
        styles: {},
        reference: '',
        selectOptions: null
    }
];


// WEBPACK FOOTER //
// ./src/app/contants/columns/columns.trip.history.ts